import React, { useRef, useState, useEffect } from "react";
import "./Home.css"
import Nav from "../components/Nav/Nav";
import Hero from "../sections/Hero/Hero";
import Preloader from "../components/Preloader/Preloader";
import AboutSection from "../sections/About/AboutSection";
import SectionThree from "../sections/Section3/SectionThree";
import SongsSection from "../sections/Song/SongsSection";
import FilmsSection from "../sections/Films/FilmsSection";
import FooterSection from "../components/Footer/FooterSection";

const Home = () => {
  const [entered, setEntered] = useState(false);
  const [musicPlaying, setMusicPlaying] = useState(false);
  const [showScreenMessage, setShowScreenMessage] = useState(false);

  const audioRef = useRef(null);

  useEffect(() => {
    const checkScreenSize = () => {
      if (window.innerWidth < 1024) {
        setShowScreenMessage(true);
      } else {
        setShowScreenMessage(false);
      }
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  const startWebsite = () => {
    setEntered(true);
    audioRef.current.play();
    setMusicPlaying(true);
  };

  const toggleMusic = () => {
    if (musicPlaying) {
      audioRef.current.pause();
      setMusicPlaying(false);
    } else {
      audioRef.current.play();
      setMusicPlaying(true);
    }
  };

  if (showScreenMessage) {
    return (
      <div className="screenError">
        <h1>This website is available on desktop only</h1>
        <p>Please open it on a larger screen</p>
      </div>
    );
  }

  return (
    <>
      <audio ref={audioRef} loop>
        <source src="/music/abdelhalim.mp3" type="audio/mpeg" />
      </audio>

      {!entered ? (
        <Preloader startWebsite={startWebsite} />
      ) : (
        <>
          <Nav toggleMusic={toggleMusic} musicPlaying={musicPlaying} />
          <Hero />
          <AboutSection />
          <SectionThree />
          <SongsSection />
          <FilmsSection />
          <FooterSection />
        </>
      )}
    </>
  );
};

export default Home;